import React, { Component } from 'react';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import mainStore from '../../../MainStore';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import AppBar from '@mui/material/AppBar';
import FormControlLabel from '@mui/material/FormControlLabel';
import { observer } from 'mobx-react';
import { fetchWithAuth } from '../../Auth/GlobalFetchWithAuth';
import ProjectServiceRow from './ProjectServiceRow';

const ProjectServices = observer(class ProjectProducts extends Component {
    constructor() {
        super();
        this.state = {
            isChanged: false,
            selectedTab: 0,
            services: [],
            isPersonal: false
        };
        this.load = this.load.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleServiceValueChanged = this.handleServiceValueChanged.bind(this);
        this.handleIsPersonalChange = this.handleIsPersonalChange.bind(this);
    };

    handleTabChange(event, newValue) {
        this.setState({ "selectedTab": newValue });
    }

    componentDidMount() {
        this.load();
    };

    componentDidUpdate(prevProps) {
        if (prevProps && prevProps.project.id !== this.props.project.id) {
            this.load();
        }
    };

    load() {
        mainStore.setMaskVisible();
        var scope = this;

        fetchWithAuth(
            'api/Project/GetProjectServices?projectId=' + this.props.project.id,
            null,
            'application/json',
            (result) => {
                let isPersonal = false;
                result.forEach(s => isPersonal = s.isPersonal);
                scope.setState({ "services": result, isPersonal: isPersonal });
                mainStore.setMaskUnvisible();
            },
            'GET'
        );
    };

    handleSave() {
        var scope = this;
        mainStore.setMaskVisible();
        fetchWithAuth(
            'api/Project/SaveProjectServices',
            JSON.stringify(this.state.services),
            'application/json',
            (result) => {
                this.setState({ isChanged: false });
                mainStore.setMaskUnvisible();
            },
            'POST'
        );
    };

    handleServiceValueChanged = id => (field, value) => {
        var services = this.state.services.slice(0);
        services.forEach(t => {
            var index = t.services.findIndex(s => s.id === id);

            if (index > -1) {
                t.services[index][field] = value;
            }
        });
        this.setState({ services: services, isChanged: true });
    }

    getSelectedTabServices(selectedTab) {
        var serviceTypes = this.state.services[selectedTab];
        if (!serviceTypes) return <div></div>;
        return serviceTypes.services.map(s => <ProjectServiceRow name={s.name} service={s} type={s.type} handleChange={this.handleServiceValueChanged(s.id)}/>);
    }

    handleIsPersonalChange(evt) {
        var serviceTypes = this.state.services.slice(0);
        serviceTypes.forEach(s => s.isPersonal = evt.target.checked);
        this.setState({ isPersonal: evt.target.checked, isChanged: true, services: serviceTypes });
    }

    render() {
        if (!this.props || !this.props.project) {
            return (<div></div>);
        }

        return (
            <div>
                <AppBar position="static">
                    <Tabs
                        value={this.state.selectedTab}
                        onChange={this.handleTabChange}
                        centered
                    >
                        {this.state.services.map(service => <Tab label={service.name} />)}
                    </Tabs>
                </AppBar>
                <div className="project-services-block clearfix">
                    {this.getSelectedTabServices(this.state.selectedTab)}
                </div>
                <FormControlLabel
                    control={
                        <Checkbox checked={this.state.isPersonal} onChange={this.handleIsPersonalChange} value="true" />
                    }
                    label="Персональная настройка"
                />
                {this.state.isChanged && <Button onClick={this.handleSave} color="secondary" variant="contained" className="work-dialog-save-button">
                    Сохранить
                </Button>}
            </div>    
        );
    }
});

export default ProjectServices;